import {
  IgButton,
  IgDivider,
  IgIconButton,
  IgSelect,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import {
  LandingPageFilterItemType,
  LandingPageFilterType,
} from "@intelligems/ig-types";
import { Stack } from "@mui/material";
import { FilterTypeMenuItems } from "@src/components/targeting/components/FilterTypeMenuItems";
import { FILTER_TYPE_OPTIONS } from "@src/components/targeting/utils/constants";

interface LandingPageMultiFilterProps {
  filters: LandingPageFilterItemType[];
  onChange: (filters: LandingPageFilterItemType[]) => void;
}

const defaultFilter = Object.keys(
  FILTER_TYPE_OPTIONS
)[0] as LandingPageFilterType;

export const LandingPageMultiFilter = ({
  filters,
  onChange,
}: LandingPageMultiFilterProps) => {
  const updateRow = (index: number, updated: LandingPageFilterItemType) => {
    const next = filters.map((f, i) => (i === index ? updated : f));
    onChange(next);
  };

  const removeRow = (index: number) => {
    onChange(filters.filter((_, i) => i !== index));
  };

  const addRow = () => {
    onChange([...filters, { filterType: defaultFilter, values: [] }]);
  };

  return (
    <Stack spacing={1}>
      {filters.map((item, index) => {
        const isNullable = ["isNull", "isNotNull"].includes(item.filterType);
        const value = item.values?.[0] ?? "";
        return (
          <Stack key={index} spacing={1}>
            {index > 0 && (
              <IgDivider>
                <IgTypography variant="caption" color="text.secondary">
                  OR
                </IgTypography>
              </IgDivider>
            )}
            <Stack direction="row" spacing={1} alignItems="center">
              <IgSelect
                value={item.filterType || defaultFilter}
                onChange={(e) => {
                  const newType = e.target.value as LandingPageFilterType;
                  const isNewNullable = ["isNull", "isNotNull"].includes(
                    newType
                  );
                  updateRow(index, {
                    filterType: newType,
                    values: isNewNullable ? [] : [value],
                  });
                }}
              >
                {FilterTypeMenuItems()}
              </IgSelect>
              <IgTextField
                disabled={isNullable}
                fullWidth
                placeholder="https://example.com/products"
                value={isNullable ? "" : value}
                onChange={(e) => {
                  updateRow(index, { ...item, values: [e.target.value] });
                }}
              />
              <IgIconButton
                onClick={() => removeRow(index)}
                iconSize={16}
                iconType="clear"
              />
            </Stack>
          </Stack>
        );
      })}
      <IgButton
        variant="text"
        onClick={addRow}
        sx={{ alignSelf: "flex-start" }}
      >
        + Add filter
      </IgButton>
    </Stack>
  );
};
